var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

$('.custom-product-thumbnail').owlCarousel({
  	dots:false,
	loop:true,
    margin:10,
    nav:true,
    responsive:{
        0:{
            items:3
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
});


$('.custom-gallery2').owlCarousel({
    loop:true,
    margin:10,
    autoplay:true,
    autoplayTimeout:5000,
    autoplayHoverPause:true,
    nav:true,
    navText: ["<img src='//cdn.shopify.com/s/files/1/0073/9583/5986/files/arrow-left.png' class='custom-gallery2-arrow'>", "<img src='//cdn.shopify.com/s/files/1/0073/9583/5986/files/arrow-right.png' class='custom-gallery2-arrow'>"],
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})


